import React, { useEffect } from 'react'
import { clearSignals } from "Pages/BusinessLogistics/Analytics/Page/@signals"
import { Grid } from "@mui/material"
import EuropcarAnalyticsFilters from "Pages/BusinessLogistics/Analytics/Page/Filters"
import { EuropcarCards, EuropcarColumnChart, EuropcarInfoBlock } from "Pages/BusinessLogistics/Analytics/Page/@components"
import { REQUEST_TYPE } from "Pages/BusinessLogistics/Analytics/Page/@constants"


export default function EuropcarAnalyticsContent() {

	useEffect(() => {
		return () => {
			clearSignals()
		}
	}, [])
	
	return <Grid container spacing={2}>
		<Grid item xs={8}>
			<EuropcarAnalyticsFilters/>
		</Grid>
		<Grid item xs={12}/>
		<Grid item xs={2}>
			<EuropcarCards/>
		</Grid>
		<Grid item xs={10}>
			<EuropcarColumnChart/>
		</Grid>
		<Grid item xs={4}>
			<EuropcarInfoBlock label={REQUEST_TYPE.COUNTRY}/>
		</Grid>
		<Grid item xs={4}>
			<EuropcarInfoBlock label={REQUEST_TYPE.USER}/>
		</Grid>
		<Grid item xs={4}>
			<EuropcarInfoBlock label={REQUEST_TYPE.SITE}/>
		</Grid>
	</Grid>

}